import { GetQueryByIdParams } from '../../types';
import { ReadJob } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const getJobById = async (
  params: GetQueryByIdParams<ReadJob>,
): Promise<ReadJob> => {
  return await tinctApi.jobs.getJob(params);
};

export const useGetJobById = (
  params: GetQueryByIdParams<ReadJob>,
  options?: Omit<UseQueryOptions<ReadJob, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['job', params.id, params.fields],
    queryFn: () => getJobById(params),
    ...options,
  });
